/**
 * Template Service
 * Handles API calls for video template management
 */

import { api } from '@/lib/axios';
import type {
  VideoTemplate,
  TemplateSelection,
  TemplateConfiguration,
  SetTemplateSelectionRequest,
  UpdateTemplateConfigurationRequest,
} from '@/types/template';

export const templateService = {
  /**
   * Get available templates (admin)
   */
  async getTemplates(): Promise<{ templates: VideoTemplate[] }> {
    const response = await api.get('/v1/admin/video_templates');
    return response.data;
  },

  /**
   * Get current template selection
   */
  async getSelection(): Promise<TemplateSelection> {
    const response = await api.get<TemplateSelection>('/v1/admin/template_selection');
    return response.data;
  },

  /**
   * Set template selection
   */
  async setSelection(data: SetTemplateSelectionRequest): Promise<void> {
    await api.put('/v1/admin/template_selection', data);
  },

  /**
   * Get template configuration (superadmin)
   */
  async getConfiguration(restaurantId: string): Promise<TemplateConfiguration> {
    const response = await api.get<TemplateConfiguration>(
      `/v1/superadmin/restaurants/${restaurantId}/template_configuration`
    );
    return response.data;
  },

  /**
   * Update template configuration (superadmin)
   */
  async updateConfiguration(
    restaurantId: string,
    data: UpdateTemplateConfigurationRequest
  ): Promise<TemplateConfiguration> {
    const response = await api.put<TemplateConfiguration>(
      `/v1/superadmin/restaurants/${restaurantId}/template_configuration`,
      data
    );
    return response.data;
  },
};
